import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Box} from '@mui/material';
import {useDispatch} from 'react-redux';

import ArrBanner from '../../components/common/arr-banner/ArrBanner';
import {ReactComponent as ErrorIcon} from '../../../src/assets/images/error-icon.svg';
import {setAuthenticatedUser} from '../../redux/slice/authenticatedUserSlice';
import {apiClient} from '../../api/apiClient';

const SSOLoginCallBack = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [error, setError] = useState<string | null>(null);
  const [, setLoading] = useState(true);

  useEffect(() => {
    const loadUserContext = async () => {
      try {
        const response = await apiClient.get(
          '/usermanagement/api/v1/login/loggedinusercontext',
          {
            withCredentials: true,
            headers: {
              accept: 'application/json',
              Authorization: 'abcd',
            },
          }
        );

        const userData = response.data;

        dispatch(
          setAuthenticatedUser({
            userId: userData.userId,
            baseRoleId: userData.baseRoleId,
            roleId: userData.roleId,
            entityId: userData.entityId,
            projectId: userData.projectId,
            securityGroupId: userData.securityGroupId,
            landingPage: userData.landingPage,
            emailID: userData.emailID,
            roleName: userData.roleName ?? '',
            userName: userData.userName,
            firstName: userData.firstName ?? '',
            lastName: userData.lastName ?? '',
            uuid: userData.uuid ?? '',
            token: '',
          })
        );
        navigate(userData.landingPage || '/', {replace: true});
        sessionStorage.removeItem('login-email');
      } catch (err) {
        console.error('SSO callback failed:', err);
        setError('Authentication failed. Please try signing in again.');
        navigate('/login', {replace: true});
      } finally {
        setLoading(false);
      }
    };

    loadUserContext();
  }, [dispatch, navigate]);

  if (error) {
    return (
      <Box role="alert" aria-live="assertive">
        <ArrBanner
          type="contextual"
          variant="error"
          bannerContent={error}
          startIcon={<ErrorIcon aria-hidden="true" />}
          dataTestId="sso-login-banner"
        />
      </Box>
    );
  }

  return null;
};

export default SSOLoginCallBack;
